class RecipeSaveToListController {
    constructor(recipeListsService, moveFocus, $state, shopperService, loginService, sessionStorage) {
        this.recipeListsService = recipeListsService;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
    }

    $onInit() {
        this.pendingSaveRecipeStorageKey = `RecipeSaveToListController:savedRecipeBeforeLogin:${this.recipe.ID}`;

        const savedRecipeBeforeLogin = this.sessionStorage.getJsonAndRemove(this.pendingSaveRecipeStorageKey);

        if (!this.shopperService.IsGuest && savedRecipeBeforeLogin === this.recipe.ID) {
            this.saveRecipe(savedRecipeBeforeLogin);
        }
    }

    saveRecipe(recipeId = this.recipe.ID) {
        this.recipeListsService.saveRecipeToList(recipeId).then(() => {
            this.recipe.IsFavouriteRecipe = true;
            this.srMessage = `${this.recipe.Title} saved to my favourite recipes`;
            this.moveFocus(`#recipe-recipeSaveToList-${recipeId}`);
        });
    }

    keepRecipe() {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, () => {
                this.sessionStorage.setJson(this.pendingSaveRecipeStorageKey, this.recipe.ID);
            });
        } else {
            this.saveRecipe(this.recipe.ID);
        }
    }

    removeSavedRecipe() {
        this.recipeListsService.removeSavedRecipe(this.recipe.ID).then(() => {
            this.srMessage = `${this.recipe.Title} is removed from my favourite recipes`;
            this.recipe.IsFavouriteRecipe = false;
            this.moveFocus(`#recipe-recipeSaveToList-${this.recipe.ID}`);
        });
    }
}

const recipeSaveToListComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: ['RecipeListsService', 'MoveFocus', '$state', 'ShopperService', 'LoginService', 'SessionStorageWrapper', RecipeSaveToListController],
    template: require('./recipe-save-to-list.component.html').trim(),
};

module.exports = {
    RecipeSaveToListController,
    recipeSaveToListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipesavetolist/recipe-save-to-list.component.js